export const MONITOR_TEMPLATES = [
  {
    id: 'login-problems',
    key: 'LOGIN_PROBLEMS',
    icon: 'shield-check-line',
    icon_color: '#F59E0B',
  },
  {
    id: 'missing-order-updates',
    key: 'MISSING_ORDER_UPDATES',
    icon: 'truck-line',
    icon_color: '#EF4444',
  },
  {
    id: 'competitor-mentions',
    key: 'COMPETITOR_MENTIONS',
    icon: 'megaphone-line',
    icon_color: '#3B82F6',
  },
  {
    id: 'feature-requests',
    key: 'FEATURE_REQUESTS',
    icon: 'lightbulb-line',
    icon_color: '#22C55E',
  },
  {
    id: 'refund-requests',
    key: 'REFUND_REQUESTS',
    icon: 'money-dollar-circle-line',
    icon_color: '#8B5CF6',
  },
  {
    id: 'cancellation-intent',
    key: 'CANCELLATION_INTENT',
    icon: 'logout-box-line',
    icon_color: '#EC4899',
  },
  {
    id: 'payment-failures',
    key: 'PAYMENT_FAILURES',
    icon: 'bank-card-line',
    icon_color: '#0EA5E9',
  },
  {
    id: 'product-errors',
    key: 'PRODUCT_ERRORS',
    icon: 'bug-line',
    icon_color: '#EF4444',
  },
  {
    id: 'issue-still-unresolved',
    key: 'ISSUE_STILL_UNRESOLVED',
    icon: 'refresh-line',
    icon_color: '#F59E0B',
  },
  {
    id: 'escalation-requests',
    key: 'ESCALATION_REQUESTS',
    icon: 'headphone-line',
    icon_color: '#8B5CF6',
  },
];
